module.exports = __webpack_public_path__ + "images/paypal.d7b910e4fdd7555b93d0cc7b68d22180.svg";